import React from "react";
import PostPagination from "../../utils/pagination.js";
import {
  List,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  Datagrid,
  Responsive,
  required,
  Toolbar,
  SaveButton,
  FileInput,
  ImageField,
} from "react-admin";
import RichTextInput from 'ra-input-rich-text';

export const ListLocation = props => (
  <List title="Locatii" {...props} bulkActions={false} pagination={<PostPagination />}>
    <Responsive
      medium={
        <Datagrid rowClick="edit">
          <TextField sortable={false} source="name" textAlign="left" label="Nume" />
        </Datagrid>
      }
    />
  </List>
);

const LocationName = ({ record }) => {
  return <span>Administreaza {record ? `${record.name}` : ""}</span>;
};

const CustomToolbar = props => (
  <Toolbar {...props}>
      <SaveButton />
  </Toolbar>
);

export const LocationEdit = props => (
  <Edit title={<LocationName />} {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list">
      <TextInput validate={required()} source="name" label="Nume"  />
      <TextInput 
        source="title" 
        label="Titlu" 
        multiline={true}
        rows={2}
        fullWidth
      />
      <TextInput 
        source="titleEn" 
        label="Titlu (EN)" 
        multiline={true}
        rows={2}
        fullWidth
      />
      <RichTextInput 
        source="description" 
        label="Descriere"
        fullWidth
      />
      <RichTextInput 
        source="descriptionEn" 
        label="Descriere (EN)"
        fullWidth
      />
      <FileInput source="logoLocation" label="Logo Locatie" accept="image/*">
        <ImageField source="sourceValue" title="filename" />
      </FileInput>
      <TextInput 
        source="iframeLocation" 
        label="URL Google Maps (Iframe)" 
        multiline={true}
        rows={3}
        fullWidth
      />
    </SimpleForm>
  </Edit>
);

export const LocationCreate = props => (
  <Create title="Add location" {...props}>
    <SimpleForm redirect="list">
      <TextInput validate={required()} source="name" label="Nume"  />
      <TextInput 
        source="title" 
        label="Titlu" 
        multiline={true}
        rows={4}
        fullWidth
      />
      <TextInput 
        source="titleEn" 
        label="Titlu (EN)" 
        multiline={true}
        rows={4}
        fullWidth
      />
      <RichTextInput 
        source="description" 
        label="Descriere"
        fullWidth
      />
      <RichTextInput 
        source="descriptionEn" 
        label="Descriere (EN)"
        fullWidth
      />
      <FileInput source="logoLocation" label="Logo Locatie" accept="image/*">
        <ImageField source="sourceValue" title="filename" />
      </FileInput>
      <TextInput 
        source="iframeLocation" 
        label="URL Google Maps (Iframe)" 
        multiline={true}
        rows={3}
        fullWidth
      />
    </SimpleForm>
  </Create>
);
